const TRANSLATION = {
  common: {
    loading: 'Loading',
  },
  i18n: {
    English: 'English',
    Spanish: 'Spanish',
    Russian: 'Russian',
    'Portuguese (Brazil)': 'Portuguese (Brazil)',
    Indonesian: 'Indonesian',
    Czech: 'Czech',
    German: 'German',
    French: 'French',
    Italian: 'Italian',
    Dutch: 'Dutch',
    Polish: 'Polish',
    Vietnamese: 'Vietnamese',
    Turkish: 'Turkish',
    Ukrainian: 'Ukrainian',
    Chinese: 'Chinese Simplified',
    'Traditional Chinese': 'Chinese Traditional',
    Japanese: 'Japanese',
    Korean: 'Korean',
    Arabic: 'Arabic',
    Persian: 'Persian',
    Thai: 'Thai',
    Hindi: 'Hindi',
    Malay: 'Malay',
    province: {
      Hebei: 'Hebei Province',
      Shanxi: 'Shanxi Province',
      Liaoning: 'Liaoning Province',
      Jilin: 'Jilin Province',
      Heilongjiang: 'Heilongjiang Province',
      Jiangsu: 'Jiangsu Province',
      Zhejiang: 'Zhejiang Province',
      Anhui: 'Anhui Province',
      Fujian: 'Fujian Province',
      Jiangxi: 'Jiangxi Province',
      Shandong: 'Shandong Province',
      Henan: 'Henan Province',
      Hubei: 'Hubei Province',
      Hunan: 'Hunan Province',
      Guangdong: 'Guangdong Province',
      Hainan: 'Hainan Province',
      Sichuan: 'Sichuan Province',
      Guizhou: 'Guizhou Province',
      Yunan: 'Yunnan Province',
      Shaanxi: 'Shaanxi Province',
      Gansu: 'Gansu Province',
      Qinghai: 'Qinghai Province',
      Taiwan: 'Taiwan Province',
      Guangxi: 'Guangxi Zhuang Autonomous Region',
      Neimenggu: 'Inner Mongolia Autonomous Region',
      Tibet: 'Tibet Autonomous Region',
      Ningxia: 'Ningxia Hui Autonomous Region',
      Xinjiang: 'Xinjiang Uyghur Autonomous Region',
      HongKong: 'Hong Kong Special Administrative Region',
      Macau: 'Macau Special Administrative Region',
      Beijing: 'Beijing Municipality',
      Tianjin: 'Tianjin Municipality',
      Shanghai: 'Shanghai Municipality',
      Chongqing: 'Chongqing Municipality',
    },
  },
  pageHeader: {
    product: 'Product',
    tvcTest: 'TVC Experience Test',
    tvcEval: 'TVC Creative Evaluation',
    contactUs: 'Contact Us',
    Pricing: 'Pricing',
    Dashboard: 'Get Started',
    signIn: 'Sign in',
    signUp: 'Sign up',
    resourceCenter: 'Blog',
    all: 'All',
    news: 'News',
    insight: 'Insight',
    case: 'Case',
  },
  productSwitch: {
    common: {
      comingSoon: 'Coming Soon',
    },
    modal: {
      heroTitle: 'Please select the test you would like to run',
      heroSubtitle:
        'AdEff is ready to deliver multidimensional creative insights whenever you need.',
      remainingTimes: 'Remaining times: {{count}}',
      supportedAssets: 'Supported Assets',
      coreMetrics: 'Core Metrics',
      cognitiveNeuroscienceIndicators: 'Cognitive-neural indicators',
      consumerAttitudeIndicators: 'Consumer attitude indicators',
      outputResult: 'Output',
      dataReport: 'Data Report',
      analysisReport: 'Analysis Report',
      accessBackend: 'Get Started',
      tabs: {
        tvc: 'Horizontal Creative Test',
        portrait: 'Vertical Creative Test',
      },
      cards: {
        tvcQuick: {
          title: 'Horizontal-QuickTest',
          descriptionHighlight: 'Rapidly assess creatives to drive data‑backed decisions',
        },
        tvcBase: {
          title: 'Horizontal-CreativeDiagnosis',
          descriptionHighlight: 'Refine creative details with actionable modification suggestions',
          value1: '10–60 sec TVC/OTV',
          value2: 'Cognitive-neural indicators',
        },
        tvcSurvey: {
          title: 'Horizontal-InsightPro',
          descriptionHighlight:
            'Multi-dimensional creative analysis with strategic optimization guidance',
          value1: '10–60 sec TVC/OTV',
          value2: 'Cognitive-neural indicators',
        },
        portraitQuick: {
          title: 'Vertical-QuickTest',
          descriptionHighlight: 'Rapidly assess creatives to drive data‑backed decisions',
        },
        portraitBase: {
          title: 'Vertical-CreativeDiagnosis',
          descriptionHighlight: 'Refine creative details with actionable modification suggestions',
          value1: '5–90 sec vertical creatives',
          value2: 'Cognitive-neural indicators',
        },
        portraitSurvey: {
          title: 'Vertical-InsightPro',
          descriptionHighlight:
            'Multi-dimensional creative analysis with strategic optimization guidance',
          value1: '5–90 sec vertical creatives',
          value2: 'Cognitive-neural indicators',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Horizontal Creative Test',
          assetText: 'For 10-60 sec TVC/OTV creatives',
        },
        portrait: {
          bannerTitle: 'Vertical Creative Test',
          assetText: 'For 5-90 sec vertical creatives',
        },
      },
      items: {
        tvcQuick: {
          description: 'Quickly compare creatives and decide',
        },
        tvcBase: {
          title: 'CreativeDiagnosis',
          description: 'Second-by-second optimization to refine creatives.',
        },
        tvcSurvey: {
          title: 'InsightPro',
          description: 'Comprehensive analysis to pinpoint key issues.',
        },
        portraitBase: {
          title: 'CreativeDiagnosis',
          description: 'Second-by-second optimization to refine creatives.',
        },
        portraitQuick: {
          description: 'Quickly compare creatives and decide',
        },
        portraitSurvey: {
          title: 'InsightPro',
          description: 'Comprehensive analysis to pinpoint key issues.',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'We use cookies',
    desc: 'We use necessary cookies to ensure our website runs smoothly. With your consent, we also use analytics cookies to improve your user experience. See our Cookie Policy in our Privacy Policy.',
    btn1: 'Reject All',
    btn2: 'Accept All',
    cookiePolicy: 'Cookie Policy',
  },
  landing: {
    banner: {
      text1: 'AI-driven',
      text2: 'AD',
      text3: 'testing',
      text4: 'Creative testing and optimization platform',
      feature1: 'Content decoding',
      feature2: 'Feedback prediction',
      feature3: 'Data integration',
      feature4: 'Conclusion Synthesis ',
      btn1: 'Get a Demo',
      btn2: 'Create Project',
    },
    info: {
      title:
        'Rapid prediction of your AD creative performance to maximize ROI by Leveraging the Hypergraph Multimodal Large Language Model (HMLLM)*',
      subTitle:
        '*This model is built on extensive neuromarketing testing and multi-agent architecture.',
      detail1: 'Rapid Ad Testing',
      detail1Desc:
        "AdEff measures the target audience's attention curve, emotional fluctuations, and content engagement levels within 15 minutes, and generates detailed evaluation reports with actionable optimization insights.",
      detail2: 'Real time Evaluation of Top-Performing Ads',
      detail2Desc:
        'AdEff analyzes multiple ad creatives in real-time, identifies top performers, and provides AI-powered recommendations to maximize campaign impact.',
      detail3: 'One-Click Editing, Generating Diverse Effective Versions',
      detail3Desc:
        'AdEff supports one-click editing, enabling the rapid creation of diverse and effective versions tailored for various communication scenarios.',
    },
    advantages: {
      title: 'Advantages of AdEff',
      item1Title: 'Rapid Response',
      item1Desc: 'Reports available in as fast as <tmp>15 minutes</tmp>.',
      item2Title: 'Unique AI Model',
      item2Desc: 'Proprietary <tmp>AI model</tmp> based on audience feedback.',
      item3Title: 'Visual Charts',
      item3Desc:
        '<tmp>Visual charts</tmp> + AI-powered insights, with test reports generated in one click.',
      item4Title: 'Extensive Data Range',
      item4Desc: 'Database of <tmp>50,000+</tmp> creatives.',
      item5Title: 'Expert Team',
      item5Desc: 'Support and guidance provided by an <tmp>expert team</tmp>.',
    },
    service: {
      title: 'AdEff Service Options',
      desc: 'Choose the service option that suits your needs',
      topTitle: 'Online Self-Service',
      topRow1: 'Create and complete tests independently',
      topRow2: 'Visual charts + AI-generated reports',
      topRow3: 'Objective neuroscience metrics analysis (eye-tracking + EEG)',
      topRow4: 'Proprietary AI model testing',
      bottomTitle: 'Expert Team Service',
      bottomRow1: 'Tests created and completed by experts',
      bottomRow2:
        'Objective neuroscience metrics analysis (eye-tracking + EEG), with optional subjective metrics',
      bottomRow3: 'Visual charts + Expert analysis reports',
      bottomRow4: 'Proprietary AI model testing, with optional real human sample testing',
    },
    footer: {
      title:
        'AdEff leverages the Hypergraph Multimodal Large Language Model (HMLLM) to construct complex relationships between visual elements, EEG signals, and eye-tracking data through hypergraphs, enabling rapid testing of advertising creatives',
      email: 'Email',
      belongDesc: 'A product of <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Get Started',
  },
  contact: { title: 'Contact Us', copy: 'Copy', message: { success: 'Copy succeeded' } },
  pricing: {
    title: 'AI-Driven Creative Testing and Optimization Expert',
    starter: {
      title: 'Starter',
      desc_1: 'Suitable for small-scale testing, and ready to use upon purchase',
      desc_2: 'Suitable for small-scale testing, and ready to use upon purchase',
      timesDesc: '<strong>{{count}}</strong> times test',
      timesDesc1: '<strong>{{count}}</strong> times test',
      discount: '50% Off',
      originPrice: '-Original price:',
      desc2: 'Proprietary AI model based on audience feedback',
      desc3: 'Quick response, reports generated in as fast as 15 minutes',
      desc4: 'Rich visual charts',
      desc5: 'Professional AI insights',
      desc6: 'Global database and benchmarks',
      cardDesc1: 'Limited-time discount, only {{pricePerTest}}',
      cardDesc2: 'Credits never expire',
    },
    premium: {
      time: 'test',
    },
    unlimited: {
      title: 'Unlimited',
      cardDesc1: 'Only {{pricePerTest}}',
      cardDesc2: 'Credits valid for one year',
      cardDesc3: 'Self based Benchmark',
      planDesc500: 'Enjoy up to 500 tests throughout the year',
      planDesc1000: 'Enjoy up to 1,000 tests throughout the year',
    },
    benefits: {
      title: 'Why choose AdEff?',
      subtitle: 'With AdEff, you get access to the following benefits:',
      expertSupport: 'Support and guidance provided by an expert team',
      moreNeedsTitle: 'Looking for more options?',
      customPlanPrefix: 'We offer flexible packages, custom solutions — contact us',
      customPlanSuffix: 'to find the right fit.',
    },
    subscribeBtn: 'Contact Us',
    contactUs: 'Contact Us',
  },
  login: {
    loginText: 'Log in',
    signUpText: '<tmp>Sign up</tmp> for free',
    text1: 'Successfully joined the team',
    text1Desc: 'AdEff uses HMLLM to build hypergraph relations for quick ad creative tests.',
    text2: 'User has joined the company',
    text3: 'Team invitation has expired',
    text4: 'The team invitation link is no longer valid.',
    optionText1: 'Already have account？',
    optionText2: "Don't have an account？",
    alertText1: 'By signing up, I agree to',
    alertText2: 'I agree to',
    termsOfService: 'Terms of Service',
    privacy: 'Privacy Policy',
    privacyTips: 'Please check the agreement box before signing up.',
    and: 'and',
    or: 'or',
    next: 'Next',
    googleLogin: 'Log in with Google',
    googleSignUp: 'Sign up with Google',
    loginWithEmail: 'Log in with Email',
    signUpWithEmail: 'Sign up with Email',
    password: 'Password',
    emailAddress: 'Email address',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot password?',
    inconsistentPassword: 'Inconsistent password',
    verificationCode: 'Verification Code',
    emptyVerificationCode: "Verification code can't be empty",
    enterVerificationCode: 'Enter Verification Code',
    sendedVerificationCode: 'The verification code has been sent to your email',
    emailOrPasswordNotCorrect: 'email or password not correct.',
    message: {
      text1: 'The input content is invalid',
      text2: 'email already registered',
      text3: 'Verification code validation error !',
      text4: 'The account has not been bound to the enterprise, please re-binding!',
      text5: 'please enter the correct email format',
      text6: 'Password minimum length of 12 characters',
      text7: 'Password must contain uppercase letters, lowercase letters and numbers',
      requestLimit: 'Request limit, please try again later',
    },
  },
  resetPwdPage: {
    submit: 'Submit',
    emailNotFound: 'Please check your email',
    emailHasSent: 'Email sent to {{email}}',
    checkYourInbox: 'Check your inbox',
    resetYourPassword: 'Reset your password',
    resetLinkHasSent:
      'An email with a link to reset your password was sent to the email address associated with your account',
    enterYourEmailAddress:
      'Enter your email address and we’ll send you a link to reset your password',
    didNotGetEmail: 'Didn’t get an email?',
    tryAgain: 'Try again',
    goBackToSign: 'Go back to sign',
    email: 'Email',
    enterYourEmail: 'Enter your email address',
    resetPassword: 'Reset password',
    resetPwdSuccess: 'Password reset successfully',
    message: {
      resetLinkCodeError: 'The code in the link is invalid',
      requestLimit: 'Request limit, please try again later',
    },
  },
  memberRequestPage: {
    title: 'Member Request Verification',
    subTitle: 'Request From:',
    deny: 'Deny',
    approve: 'Approve',
    teamFull: 'Team Full',
    yourTeamIsFull:
      'Your team is full. You can contact us to get more membership or remove other members.',
    manageMembers: 'Manage members in AdEff',
    requestApproved: 'Request Approved',
    approvedDesc:
      'You have approved <tmp>{{name}}</tmp> to join your team notification emails have been send automatically.',
    requestDeclined: 'Request Declined',
    declinedDesc:
      'You have declined <tmp>{{name}}</tmp> to join your team notification emails have been send automatically.',
  },
  infoBindPage: {
    title: 'Ai-driven AD testing',
    desc: 'Rapid prediction of your AD creative performance to maximize ROI by Leveraging the Hypergraph Multimodal Large Language Model (HMLLM)*',
    joinAdEff: 'Join AdEff and Start a new journey',
    advantages: {
      title1: 'More Powerful',
      desc1: 'unique AI model based on substantial database',
      title2: 'More Economical',
      desc2: 'only need 10% the price of traditional methods',
      title3: 'More rapid',
      desc3: 'reports can be obtained in as little as 15 minutes',
      title4: 'Better service',
      desc4: 'access complimentary 24/7 support, and basic expert support',
    },
    username: 'Username',
    company: 'Company',
    placeOfResidence: 'Country/Region',
    invitationCode: 'Referral Code',
    createAccountForFree: 'Create account for free',
    refreshStatus: 'Refresh status',
    reapply: 'Reapply',
    bySigningUp: 'By signing up, I agree to',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    message: {
      success: 'The request to create an account has been send, please be patient!',
      success2: 'Account created successfully',
      error: 'Account creation failed, please try again later.',
      accountCreatedDirectly: 'An account has been created directly for you !',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'The request has been approved and is jumping the page for you',
      theRequestHasBeenSendAndPleaseBePatient: 'The request has been send, please be patient!',
      wrongRouting: 'Wrong routing, has been automatically jumped for you.',
      yourRequestHasBeenDeclined:
        'Your request has been declined. You can reapply to join the team or create a new account without invitation code.',
      waitingForAdministratorReview: 'Waiting for administrator review',
      thisFieldIsRequired: 'This field is required',
      pleaseEnterTheResidence: 'Please enter the country',
      invitationCodeDoesNotExist: 'Invalid referral code',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'If you are using this through an agent referral, please enter the referral code',
      pleaseEnterTheUsername: 'Please enter the username',
      pleaseEnterTheCompanyName: 'Please enter the company name',
      needRegisterAgain: 'Operation exception, please register again',
      alreadyBind: 'You have already bound the enterprise, please do not bind again',
    },
  },
  knowledgeFormPage: {
    name: 'Your Name',
    email: 'Your Email',
    companyName: 'Company Name',
    department: 'Department',
    role: 'Role',
    country: 'Country',
    province: 'Province',
    pleaseEnter: 'Please enter',
    pleaseSelect: 'Please select',
    pleaseEnterTheName: 'Please enter your name',
    pleaseEnterTheEmail: 'Please enter your email',
    pleaseEnterValidEmail: 'Please enter a valid email',
    pleaseEnterTheCompanyName: 'Please enter your company name',
    pleaseSelectTheDepartment: 'Please select your department',
    pleaseSelectTheRole: 'Please select your role',
    pleaseSelectTheCountry: 'Please select your country',
    pleaseSelectTheProvince: 'Please select your province',
    textIsRequired: 'This field is required',
    submit: 'Submit',
    download: 'Download',
    submitSuccess: 'Submit successfully',
    downloadSuccess: 'Download successfully',
    title1: 'Please fill in your information to get resources',
    title2: 'Please select the resources you want to download',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Download Report',
      downloadBtnText: 'Download PDF',
      content: 'Content',
      theEnd: 'The End',
      thankYouForWatching: 'Thank you for watching.',
      pdfProcessing: 'Processing PDF...',
      pdfProcessingDesc:
        'PDF pages: {{count}}, expected to take {{seconds}} seconds, click save after, please be patient',
      pdfProcessingDesc2: 'The current language version is not translated, cannot generate PDF',
    },
    ppt: {
      downloadBtnText: 'Download PPT',
      pptProcessingDesc: 'Processing PPT file, please be patient',
      pptProcessingDesc2: 'The current language version is not translated, cannot generate PPT',
      pptProcessingDesc3: 'Downloading PPT file, please wait...',
      translateCompleted: 'PPT translation completed',
      exportSuccess: 'PPT file exported successfully',
      exportFailed: 'PPT file export failed',
    },
    layout: {
      projectMenuText: 'Ad Testing Project',
      accountManagementText: 'Account Management',
      myAccountText: 'My Account',
      subscriptionText: 'Subscription',
      logout: 'Logout',
      dataDetails: 'Data Details',
      dataAnalysis: 'Data Analysis',
      dataOverview: 'Data Overview',
      dataComparison: 'Data Comparison',
    },
    systemMessage: {
      title: 'System Message',
      task: 'Task',
      system: 'System',
      noRelevantContent: 'No relevant content found',
      noMore: 'No more notifications.',
    },
    projectPage: {
      createProject: 'Create Project',
      searchPlaceholder: 'Search by Project/Ad/Brand Name',
      sortLabel: 'Sort by Ad Effectiveness Index',
      sortPlaceholder: 'Please select a sorting method',
      sortOption1: 'In ascending order of effect index',
      sortOption2: 'In descending order of effect index',
      filterSort: 'Filter & Sort',
      filterBenchmarkTitle: 'Filter benchmark',
      sortTitle: 'Sort',
      tabAllCreative: 'All Creative ({{count}})',
      tabGeneralCreative: 'General Creative ({{count}})',
      tabSplashCreative: 'Splash Creative ({{count}})',
      generalCreativeLabel: 'General Creative',
      splashCreativeLabel: 'Splash Creative',
      normTypePlaceholder: 'Please select benchmark type',
      totalDesc: 'Ad projects (total {{total}})',
      noRelevantContent: 'No relevant content found',
      loadMore: 'Load more',
      projectCard: {
        delete: 'Delete',
        reanalyze: 'Reanalyze',
        download: 'Download',
      },
      delete: 'Delete',
      cancel: 'Cancel',
      message: {
        deleteTitle: 'Deletion Reminder',
        delete:
          'Once you delete this project, all associated data will become inaccessible.Are you sure you want to proceed with the deletion?',
        delete1:
          'This project is a free trial project, and deleting it will not return the free trial opportunity',
        delete2:
          'This project has not started analysis yet. After deletion, your test credits will be refunded',
        deleteSuccess: 'Delete successfully!',
        analysisCountNotEnough: 'Analysis count not enough, please recharge to continue.',
        analysisFailed: 'Analysis failed, please try again later.',
        waitingQuestion:
          'A maximum of 3 projects can be analyzed simultaneously. This project has entered the waiting queue and will start analysis automatically later.',
        landscapeQuickCompleted: 'Your horizontal quick test project is complete.',
        portraitQuickCompleted: 'Your vertical quick test project is complete.',
        landscapeSurveyCompleted: 'Your horizontal insight project is complete.',
        portraitSurveyCompleted: 'Your vertical insight project is complete.',
      },
    },
    projectCreatePage: {
      createProject: 'Create Project',
      basicInformation: 'Basic Information',
      projectType: 'Project Type',
      projectName: 'Project Name',
      categoryType: 'Category',
      brandName: 'Brand Name',
      advertisingInformation: 'Advertising Information',
      adName: 'Ad Name',
      targetMarketNorm: 'Target Market Benchmark',
      norm: 'Benchmark',
      brandNorm: 'Brand Benchmark',
      taGender: 'TA Gender',
      targetMarket: 'Target Market',
      taAge: 'TA Age',
      next: 'Next',
      previous: 'Previous Step',
      confirmOrder: 'Confirm Order',
      estTime: 'Est. Time',
      minutes: 'minutes',
      consumption: 'Consumption for this order',
      testPoint: 'Test Point',
      remaining: 'Remaining',
      times: 'times',
      type: 'Type',
      purchase: 'Purchase',
      outputLanguage: 'Output Language',
      durationCategory: 'Creative Type',
      durationCategoryDesc:
        'Analysis metrics vary by creative type, please select the option that best matches your content',
      durationCategoryOptions: {
        tenPlus: 'General Creative(10s+)',
        fiveToTen: 'Splash Creative(5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Ad Creative Test',
        adCreativeTestDesc:
          'Testing audience feedback on individual ad creatives, providing analysis and recommendations.',
        adCreativeSelection: 'Ad Creative Selection',
        adCreativeSelectionDesc:
          'Comparing the feedback effects of multiple ad creatives to make a comprehensive selection.',
        adCreativeEditing: 'Ad Creative Editing',
        adCreativeEditingDesc:
          'AI intelligently filters the highlights from ad creatives and automatically generates ad content.',
        launchingSoon: 'Launching Soon',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Food & Beverage Category',
        packagedFood: 'Packaged Food',
        confectionery: 'Confectionery',
        frozenMeals: 'Frozen Meals',
        fastFood: 'Fast Food',
        beverage: 'Beverage',
        alcohol: 'Alcohol',
        dairy: 'Dairy',
        grainAndSeasoning: 'Grain and Seasoning',
        beverageMixes: 'Beverage Mixes',
        freshProduce: 'Fresh Produce',
        otherFoodAndBeverage: 'Other Food & Beverage',
        /**----------------------- */
        consumerElectronicsCategory: 'Consumer Electronics Category',
        mobilePhone: 'Mobile Phone',
        computer: 'Computer',
        smartDevice: 'Smart Device',
        phoneAccessories: 'Phone Accessories',
        computerAccessories: 'Computer Accessories',
        software: 'Software',
        camera: 'Camera',
        officeSupplies: 'Office Supplies',
        otherConsumerElectronics: 'Other Consumer Electronics',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Pharmaceuticals & Health Care Category',
        otcMedicine: 'OTC Medicine',
        prescriptionDrugs: 'Prescription Drugs',
        healthSupplements: 'Health Supplements',
        pharmaceuticalCompanies: 'Pharmaceutical Companies',
        medicalDevices: 'Medical Devices',
        medicalServices: 'Medical Services',
        pharmacy: 'Pharmacy',
        otherPharmaceuticalsAndHealthCare: 'Other Pharmaceuticals & Health Care',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Beauty/Personal Care/Cleaning Supplies Category',
        hairCare: 'Hair Care',
        womenSkincare: 'Women Skincare',
        homeCleaning: 'Home Cleaning',
        bodyCare: 'Body Care',
        feminineCare: 'Feminine Care',
        oralCare: 'Oral Care',
        menSkincare: 'Men Skincare',
        makeup: 'Makeup',
        fragrances: 'Fragrances',
        beautyServices: 'Beauty Services',
        otherBeautyAndPersonalCare: 'Other Beauty/Personal Care/Cleaning',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Maternal & Infant Products Category',
        babyFood: 'Baby Food',
        babyCareEssentials: 'Baby Care Essentials',
        babyToys: 'Baby Toys',
        otherMaternalAndInfantProducts: 'Other Maternal & Infant Products',
        /**----------------------- */
        networkAndCommunicationCategory: 'Network & Communication Category',
        mobileCarriers: 'Mobile Carriers',
        internetProviders: 'Internet Providers',
        telecomEquipment: 'Telecom Equipment',
        otherNetworkAndCommunication: 'Other Network & Communication',
        /**----------------------- */
        travelAndAccommodationCategory: 'Travel/Accommodation Category',
        localTourism: 'Local Tourism',
        bookingPlatform: 'Booking Platform',
        hotels: 'Hotels',
        airlines: 'Airlines',
        airport: 'Airport',
        otherTravelAndAccommodation: 'Other Travel & Accommodation',
        /**----------------------- */
        vehiclesCategory: 'Vehicles Category',
        motorVehicleProductsAndServices: 'Motor Vehicle Products and Services',
        carBrands: 'Car Brands',
        dealerships: 'Dealerships',
        carFinance: 'Car Finance',
        evCar: 'EV Car',
        motorcycle: 'Motorcycle',
        onlineUsedCarMarketplace: 'Online Used Car Marketplace',
        carRentalPlatform: 'Car Rental Platform',
        travelNavigation: 'Travel Navigation',
        bicycle: 'Bicycle',
        otherVehicles: 'Other Vehicles',
        /**----------------------- */
        householdAppliancesCategory: 'Household Appliances Category',
        majorAppliances: 'Major Appliances',
        healthAndPersonalCareAppliances: 'Health & Personal Care Appliances',
        majorKitchenAndBathAppliances: 'Major Kitchen & Bath Appliances',
        smallKitchenAppliances: 'Small Kitchen Appliances',
        environmentalAppliances: 'Environmental Appliances',
        cleaningAppliances: 'Cleaning Appliances',
        otherHouseholdAppliances: 'Other Household Appliances',
        /**----------------------- */
        retailAndServiceCategory: 'Retail & Service Category',
        onlineRetailEcommerce: 'Online Retail/Ecommerce',
        departmentStores: 'Department Stores',
        lifeServices: 'Life Services',
        retailServicesAndDelivery: 'Retail Services/Delivery',
        supermarkets: 'Supermarkets',
        otherRetailAndService: 'Other Retail & Service',
        /**----------------------- */
        apparelCategory: 'Clothing & Accessories Category',
        footwear: 'Footwear',
        clothing: 'Clothing',
        watchesWatchRetail: 'Watches/Watch Shop',
        jewelry: 'Jewelry',
        bags: 'Luggage/Bags',
        eyewearOpticalStores: 'Eyewear/Optical Shop',
        otherClothingAndAccessories: 'Other Clothing & Accessories',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Home Improvement & Furnishings Category',
        homeFurnishing: 'Home Furnishing',
        homeImprovement: 'Home Improvement',
        otherHomeImprovementAndFurnishings: 'Other Home Improvement & Furnishings',
        /**----------------------- */
        financialAndInsuranceCategory: 'Financial & Insurance Category',
        bank: 'Bank',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Investment & Financial Services',
        insurance: 'Insurance',
        otherFinancialAndInsurance: 'Other Financial & Insurance',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Entertainment & Leisure Category',
        socialApp: 'Social App',
        toysAndDolls: 'Toys and Dolls',
        concerts: 'Concerts',
        events: 'Events',
        movies: 'Movies',
        themeParks: 'Theme Parks',
        gambling: 'Gambling',
        onlineGaming: 'Online Gaming',
        tvChannels: 'TV Channels',
        otherEntertainmentAndLeisure: 'Other Entertainment & Leisure',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industrial & Agricultural Category',
        industrialSupplies: 'Industrial Supplies',
        agriculturalSupplies: 'Agricultural Supplies',
        otherIndustrialAndAgricultural: 'Other Industrial & Agricultural',
        /**----------------------- */
        petLifeCategory: 'Pet Industry Category',
        petFood: 'Pet Food',
        petSupplies: 'Pet Supplies',
        otherPetLife: 'Other Pet Industry',
        /**----------------------- */
        educationAndLearningCategory: 'Education & Learning Category',
        onlineLearning: 'Online Learning',
        schools: 'Schools',
        skillCourses: 'Skill Courses',
        tutoring: 'Tutoring',
        universities: 'Universities',
        otherEducationAndLearning: 'Other Education & Learning',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Community & Public Service Category',
        charityCampaigns: 'Charity Campaigns',
        ngoAds: 'NGO Ads',
        otherCommunityAndPublicService: 'Other Community & Public Service',
        /**----------------------- */
        otherCategory: 'Other Category',
        governmentAdvertising: 'Government Advertising',
        realEstateAdvertising: 'Real Estate Advertising',
        otherAdvertising: 'Other Advertising',
      },
      genderSelect: {
        male: 'Male',
        female: 'Female',
        all: 'All',
      },
      targetMarketSelect: {
        China: 'China',
        HongKongChina: 'Hong Kong, China',
        MacauChina: 'Macau, China',
        TaiwanChina: 'Taiwan, China',
        Japan: 'Japan',
        Korea: 'Korea',
        Mongolia: 'Mongolia',
        Singapore: 'Singapore',
        Thailand: 'Thailand',
        Vietnam: 'Vietnam',
        Malaysia: 'Malaysia',
        Philippines: 'Philippines',
        Indonesia: 'Indonesia',
        Cambodia: 'Cambodia',
        Laos: 'Laos',
        India: 'India',
        SaudiArabia: 'Saudi Arabia',
        Turkey: 'Turkey',
        Israel: 'Israel',
        UnitedArabEmirates: 'United Arab Emirates',
        Qatar: 'Qatar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'United Kingdom',
        France: 'France',
        Germany: 'Germany',
        Netherlands: 'Netherlands',
        Belgium: 'Belgium',
        Austria: 'Austria',
        Italy: 'Italy',
        Spain: 'Spain',
        Portugal: 'Portugal',
        Greece: 'Greece',
        Sweden: 'Sweden',
        Norway: 'Norway',
        Finland: 'Finland',
        Denmark: 'Denmark',
        Estonia: 'Estonia',
        Latvia: 'Latvia',
        Russia: 'Russia',
        Poland: 'Poland',
        CzechRepublic: 'Czech Republic',
        Hungary: 'Hungary',
        Romania: 'Romania',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Slovakia',
        Slovenia: 'Slovenia',
        Ukraine: 'Ukraine',
        UnitedStates: 'United States',
        Canada: 'Canada',
        Mexico: 'Mexico',
        Brazil: 'Brazil',
        LatinAmerica: 'Latin America',
        Australia: 'Australia',
        NewZealand: 'New Zealand',
        Other: 'Other',
      },
      languageSelect: {
        english: 'English',
        chinese: 'Chinese',
        japanese: 'Japanese',
        korean: 'Korean',
        french: 'French',
        traditionalChinese: 'Traditional Chinese',
      },
      placeholder: {
        projectName: 'Please enter the project name',
        category: 'Select the category',
        brandName: 'Please enter the brand name',
        adName: 'Please enter the ad name',
        norm: 'Please select benchmark',
        taGender: 'Please select gender',
        targetMarket: 'Please select target market',
        taAge: 'Please select age',
        lowerLimit: 'Lower Limit',
        upperLimit: 'Upper Limit',
        outputLanguage: 'Please select the output language',
      },
      step: {
        step1: 'Project Information Entry',
        step2: 'Order Information Confirmation',
      },
      message: {
        success: 'Create successfully',
        videoDurationOver60s: 'Video duration over {{max}}s',
        videoDurationLessThan10s: 'Video duration less than {{min}}s',
        videoDurationNeedOver10s: 'Video duration must be over 10s',
        videoDurationNeedWithin5To10s: 'Video duration must be between 5s and 10s',
        videoDurationNotMatchDurationCategory:
          'The current video duration does not meet this creative type. Please re-upload and try again.',
        videoUploadingCannotSwitchDurationCategory:
          'You cannot switch creative type while the video is uploading. Please wait for the upload to finish.',
        videoFormatOrDurationError:
          'Unable to read the video format or duration. Please check the video file and try again.',
        videoSizeOver200M: 'Video size over 256M',
        videoLandscape: 'Video needs to be in landscape format',
        videoPortrait: 'Video needs to be in portrait format',
        clickToUploadTestVideo: 'Click to Upload Test Video',
        uploadFailed: 'Upload failed, please upload again',
        uploadDesc1: 'Support landscape video files in MP4, MOV',
        uploadDescPortrait: 'Support portrait video files in MP4, MOV',
        uploadDesc2: 'with a file size limit of 256MB',
        formNotCompleted: 'Please fill in the complete information.',
        uploadAdVideo: 'Please upload a ad-video',
        inputInvalid: 'The input content is invalid',
        insufficientTestPoints: 'Insufficient test attempts. Please recharge to continue.',
        reviewProjectInfo:
          'Please carefully review your project information. Once the order is confirmed, it cannot be changed a second time.',
        waitingDesc:
          'Up to 3 projects can be analyzed simultaneously. Additional projects will enter a waiting queue and be processed sequentially by the system.',
        ageRangeInvalid: 'Age range only supports 20-55',
        normDesc: 'Unlimited copyright benefits, enterprise-customized own benchmark value',
      },
    },
    projectDetailPage: {
      testResults: 'Test Results',
      share: 'Share',
      shareFailed: 'Share failed',
      shareModal: {
        title: 'Share',
        desc: 'Copy the text below and share it on social media.',
        saveImage: 'Save Image',
        copyText: 'Copy Text',
        copySuccess: 'Copied',
        copyFailed: 'Copy failed',
        textTemplate:
          'Wow! My AI creative beat {{score}}% of peers on AdEff! Data is the real deal! AdEff AI Creative Testing is free now. Check your score at {{hostname}}. Get 5 free tests, wishing you rave reviews too!',
      },
      sharePoster: {
        createdByYou: 'Created by you',
        scoreTemplate: 'Outperformed <score>{{score}}</score> of AIGC creatives',
        statsAt: 'Generated at ',
        certification: 'Creative Certification',
        footerText: 'Keep creating and bring more outstanding works!',
      },
      basicInformation: 'Basic Information',
      waiting: 'Waiting',
      ongoing: 'Ongoing',
      failed: 'Failed',
      tryAgain: 'Try Again',
      videoAnalysisFailed: 'Video Analysis failed',
      message: {
        projectNotFound: 'Project not found',
      },
      primaryAnalysis: 'Key Performance',
      detailAnalysis: 'Moment Analysis',
      heatmapAnalysis: 'Heatmap',
      analysisStepDesc:
        'AI has completed all analytical tasks. The detailed analysis is as follows',
      analysisWaitingDesc:
        'Up to 3 projects can be analyzed simultaneously. Additional projects will enter a waiting queue and be processed sequentially by the system.',
      aiTip: 'The report content is generated by AI and for reference only',
      subAnalysisDescription: {
        adVideoScore: 'AdEff index',
        adVideoScoreDesc:
          'AdEff index is a comprehensive indicator of ad effectiveness, capable of predicting short-term and long-term sales effects of ads.',
        norm: 'Benchmark',
        normDesc:
          'Industry or historical data benchmark, used for horizontal comparison of ad performance.',
        attentionIndex: 'Attention Index',
        attentionIndexDesc:
          'Audience visual attention concentration, reflecting the ability of ad content to attract viewers.',
        emotionIndex: 'Emotion Index',
        emotionIndexDesc:
          'Audience positive emotion activation, reflecting the ability of ads to trigger immediate emotional responses.',
        cognitionIndex: 'Recognition Index',
        cognitionIndexDesc:
          'Audience cognitive processing level, reflecting the extent to which they engage with ad content.',
        theGolden3Seconds: 'The Golden 3s',
        theGolden3SecondsDesc: 'The first 3 seconds of ads are crucial for determining success.',
        informationTransmission: 'Key Message Moment',
        informationTransmissionDesc:
          'Measure the ability of ad information moments to capture audience attention and stimulate interest.',
        brandRelevance: 'Brand Moment',
        brandRelevanceDesc:
          'Measure the ability of brand moments to capture audience attention and stimulate interest.',
        interestStimulation: 'Interest Moment',
        interestStimulationDesc:
          'Key content moments that trigger emotional resonance and active cognition.',
        theEnding3Seconds: 'The Ending 3s',
        theEnding3SecondsDesc:
          'Based on the peak-end rule, the last 3 seconds of ads are crucial for reinforcing viewer attention and strengthening information transmission.',
      },
      infoDrawer: {
        basicInformation: 'Basic Information',
        advertisingInformation: 'Advertising Information',
        projectName: 'Project Name',
        brandName: 'Brand Name',
        category: 'Category',
        norm: 'Target Market Benchmark',
        normLabel: 'Benchmark',
        brandNorm: 'Brand Benchmark',
        adName: 'Ad Name',
        taGender: 'TA Gender',
        targetMarket: 'Target Market',
        taAge: 'TA Age',
        ageRange: '{{start}} to {{end}} years old',
        modify: 'Modify',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      videoView: {
        eyeMovementRatio: 'Attention index',
        cognitiveEngagement: 'Recognition index',
        emotionRecognition: 'Emotion index',
        subjectiveResponseCurve: 'Subjective Response Curve',
        realtimeData: 'Realtime Data',
        panoramicData: 'Panoramic Data',
        indexAnalysis: 'Index Analysis',
        advantage: 'Strengths',
        disadvantage: 'Weaknesses',
        suggestions: 'Suggestion',
        adVideoScore: 'AdEff index',
        norm: 'Benchmark',
        analysisStepTitle1: 'Content Decoding',
        analysisStepTitle2: 'Feedback Prediction',
        analysisStepTitle3: 'Data Integration',
        analysisStepTitle4: 'Conclusion Inference',
        analysisStepDesc1: 'Decoding visual, audio, text, and structure of ad content.',
        analysisStepDesc2: 'Predicting audience eye movement and EEG responses per second.',
        analysisStepDesc3: 'Merging ad content with audience response data.',
        analysisStepDesc4: 'Generating evaluations and recommendations via inference models.',
        keyResult: 'Key Results',
        videoChart: {
          videoFailed: 'Video playback failed',
          videoFailedAction:
            'Please refresh and try again. If the problem continues after multiple refreshes,  please contact us for assistance.',
        },
      },
      storyboardView: {
        summary: 'Summary',
        advantages: 'Strengths',
        disadvantages: 'Weaknesses',
        suggestions: 'Suggestions',
        keyResult: 'Key Results',
        norm: 'Benchmark',
        theGolden3Seconds: 'The Golden 3s',
        informationTransmission: 'Key Message Moment',
        brandRelevance: 'Brand Moment',
        interestStimulation: 'Interest Moment',
        theEnding3Seconds: 'The Ending 3s',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Email',
      username: 'Username',
      password: 'Password',
      setPasswordToEnableEmailLogin: 'Set password to enable email login',
      uid: 'UID',
      contactAndReceiveNotifications: 'Contact and Receive notifications',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Receive emails about AdEff latest updates with this email.',
      myWorkspace: 'My Workspace',
      newRequest: 'New Request',
      invitationCode: 'Referral Code',
      userName: 'Username',
      invitationCodeDesc:
        'Each team has a unique invitation code used for new users to request to join the team during registration',
      table: {
        userName: 'User Name',
        email: 'Email',
        operation: 'Operation',
        admin: 'admin',
        remove: 'Remove',
        deny: 'Deny',
        approve: 'Approve',
      },
      message: {
        yourTeamIsFull:
          'Your team is full. You can contact us to get more membership or remove other members.',
        invitationLinkSent: 'An invitation link has been sent to this email address !',
        removeReminder: 'Remove Reminder',
        remove: 'Remove',
        removeMember:
          'After removing a member, the content created by that member will still be retained. Do you want to proceed with removing the member?',
        removeMemberSuccess: 'Member removed successfully !',
        ok: 'ok',
        contactUs: 'contact us',
        applicationProcessedSuccessfully: 'Application processed successfully !',
        notificationSettingsTurnedOn: 'Notification settings are turned on',
        notificationSettingsTurnedOff: 'Notification settings are turned off',
        setPassword: 'Set Password',
        passwordConfirm: 'Confirm',
        passwordCancel: 'Cancel',
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        pleaseEnterTheOldPassword: 'Please enter the old password',
        pleaseEnterTheNewPassword: 'Please enter the new password',
        incorrectEntryOfOriginalPassword: 'Incorrect entry of original password',
        passwordUpdatedSuccessfully: 'Password updated successfully',
        changeUsername: 'Change Username',
        confirm: 'Confirm',
        cancel: 'Cancel',
        username: 'Username',
        pleaseEnterTheNewUsername: 'Please enter the new username',
        userNameUpdatedSuccessfully: 'Username updated successfully',
        addMemberToWorkspace: 'Add New Member To Workspace',
        notAdminOperate: 'Not admin, cannot operate',
        emailAddress: 'Email Address',
        send: 'Send',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'We will send an invitation email to this address for confirmation.',
        workspaceMemberShip: 'Workspace memberShip',
        forMoreMembership: 'for more membership',
        reachedTheCeiling: 'The number of people has reached the ceiling.',
        incorrectMailboxFormat: 'Incorrect mailbox format',
        member: 'Member',
        changeCorpNameTitle: 'Change Corp Name',
        changeCorpNameLabel: 'Corp Name',
        pleaseEnterTheCorpName: 'Please enter the corp name',
        changeCorpNameSuccess: 'Corp name changed successfully',
        changeCorpNameFailed: 'Corp name change failed',
        noPermission: 'You do not have permission to change the corp name',
      },
    },
    subscriptionPage: {
      currentPlan: 'Current Plan',
      getInvoice: 'Get your invoice',
      remainingTimes: 'remaining times',
      purchaseMore: 'Purchase more',
      contactUs: 'Contact Us',
      teamPlan: 'Expert team service',
      unlimited: 'Unlimited',
      dueDate: 'Due Date',
      table: {
        usageRecords: 'Usage Records',
        date: 'Date',
        projectName: 'Project Name',
        projectType: 'Project Type',
        usageCount: 'Count',
        userName: 'User Name',
        noRelevantContent: 'No relevant content found',
      },
    },
    dataDetailPage: {
      baseData: 'Base Data',
      totalProjects: 'Total Projects',
      totalProjectsDesc:
        'The number of valid projects participating in the advertising effectiveness evaluation.',
      // averageEffectivenessIndex: 'Average Effectiveness Index',
      // averageEffectivenessIndexDesc:
      //   'The average advertising effectiveness index of all valid projects.',
      localNormProjects: 'Local Benchmark Projects',
      brandNormProjects: 'Brand Benchmark Projects',
      normProject: 'Target Market Benchmark Project',
      brandNormProject: 'Brand Benchmark Project',
      localNorm: 'Local Benchmark',
      localNormDesc:
        'The average advertising performance index of effective campaigns with your country as the target market.',
      norm: 'Benchmark',
      brandNorm: 'Brand Benchmark',
      brandNormDesc:
        'The average advertising performance index of effective campaigns with your customized brand benchmark value.',
      localProjectPassRate: 'Local Project Pass Rate',
      projectPassRate: 'Project Pass Rate',
      brandProjectPassRate: 'Brand Project Pass Rate',
      projectPassRateDesc:
        'The proportion of projects with advertising effectiveness index scores above the benchmark value out of the total number of evaluated projects.',
      advertisingEffectivenessIndexDistribution: 'Advertising Effectiveness Index Distribution',
      advertisingEffectivenessIndexDistributionDesc:
        'Shows the proportion of projects in different advertising effectiveness index ranges.',
      item: 'items',
    },
    dataComparisonPage: {
      createCompare: 'New Comparison',
      createCompareDesc: 'Select multiple projects to compare, up to 10 projects.',
      startCompare: 'Start Comparison',
      compareReport: 'Comparison Reports',
      searchPlaceholder: 'Search comparison report name',
      emptyText: 'No comparison reports yet. Select projects to compare first.',
      searchEmptyText: 'No comparison reports found.',
      deleteTitle: 'Delete Comparison Report',
      deleteConfirm: 'Are you sure you want to delete this comparison report? This action cannot be undone.',
      projectCount: '{{count}} projects',
    },
    dataComparisonStartPage: {
      back: 'Back',
      basicInfo: 'Basic Information',
      reportName: 'Report Name:',
      reportNamePlaceholder: 'Enter comparison report name',
      norm: 'Benchmark:',
      normPlaceholder: 'Select benchmark',
      normTip: 'Select the benchmark used for project comparison',
      selectProject: 'Select Projects',
      searchPlaceholder: 'Search by project/ad/brand name',
      selectedCountPrefix: ' Selected ',
      selectedCountSuffix: ' projects, up to {{max}} projects',
      startCompare: 'Start Comparison',
      save: 'Save',
      cancel: 'Cancel',
      maxSelectedWarning: 'You can select up to 10 projects',
      reportNameRequired: 'Enter comparison report name',
      normRequired: 'Select benchmark',
      projectRequired: 'Select projects',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Comparison Report Name',
      reportNotFound: 'Report not found',
      back: 'Back',
      modify: 'Edit',
      deletedProjectTip: 'The following projects: {{names}} have been deleted. Confirm to update the comparison report and remove them.',
      confirmDeletedProjects: 'Confirm',
      metricScore: 'Indicator Score',
      tabDimension: 'Five Force',
      tabMoment: 'Key Moment',
      tabAttitude: 'Consumer Attitude',
      adeffScore: 'AdEff Score',
      brandName: 'Brand Name',
      projectName: 'Project Name',
      industry: 'Industry',
      targetMarket: 'Target Market',
      gender: 'TA Gender',
      age: 'TA Age',
      adProject: 'Ad Project',
      normLabel: 'Benchmark',
      mixedCreativeBenchmarkTip: 'No benchmark is available when comparing general creatives and splash creatives simultaneously.',
      emptyProject: 'Select projects to view comparison data',
      viewProjectDetail: 'View Project Details',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Attention Force',
        infectivity: 'Emotional Force',
        delivery: 'Message Force',
        brand: 'Brand Force',
        persuasion: 'Persuasive Force',
        gazeRecognition: 'Gaze Recognition',
        emotionRecognition: 'Emotion Recognition',
        engagementRecognition: 'Engagement Recognition',
        goldenSeconds: 'Golden 3s Performance',
        brandMoment: 'Brand Performance',
        productMoment: 'Interest Peak',
        messageMoment: 'Key Message Performance',
        endingSeconds: 'Ending 3s Performance',
        likeability: 'Liking',
        newInformation: 'New Information',
        messageRelevance: 'Message Relevance',
        comprehension: 'Comprehension',
        credibility: 'Credibility',
        brandLinkage: 'Brand Linkage',
        uniqueness: 'Uniqueness',
        learnMoreIntent: 'Willingness to Learn More',
        purchaseIntent: 'Purchase Intention',
        recommendIntent: 'Shareability',
        brandLikeabilityLift: 'Brand Likeability Lift',
        purchaseIntentionLift: 'Purchase Intention Lift',
        attentionIndex: 'Attention Index',
        emotionIndex: 'Emotion Index',
        cognitionIndex: 'Recognition Index',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Regular Creative Project',
      regularCreative: 'Regular Creative',
      splashCreativeProject: 'Splash Creative Project',
      splashCreative: 'Splash Creative',
      projects: 'Projects',
      localNorm: 'Local Benchmark',
      projectPassRate: 'Project Pass Rate',
      passRate: 'Pass Rate',
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Your TVC creative evaluation project is complete.',
        title: {
          text1: 'Advertisement Creative Testing',
          text2: 'Test Report',
        },
        flowAnalysis: {
          desc1: 'AdEff is deconstructing your video ad',
          desc2: 'Video deconstruction complete',
          desc3: 'Analyzing consumer visual attention',
          desc4: 'Analyzing visual focus based on consumer profiles',
          desc5: 'Generating attention heatmap',
          desc6: 'Dynamic heatmap generated',
          desc7: 'Measuring cognitive-neural responses',
          desc8: 'Tracking gaze, emotion, and engagement second by second',
          desc9: 'Generating neural response curve',
          desc10: 'Neural response curve‌ generated',
          desc11: 'Analyzing performance at key moments',
          desc12:
            'Measuring cognitive–neural responses during: Golden 3s, Message Moment, Brand Moment, Interest Peak, and Ening 3s',
          desc13: 'Synthesizing key moment metrics',
          desc14: 'Key moment analysis completed',
          desc15: 'Analyzing consumer attitudes',
          desc16: 'Analyzing attitudes toward the brand, product, and content',
          desc17: 'Synthesizing attitude metrics',
          desc18: 'Attitudinal metrics completed',
          desc19: 'Generating five force drive scores',
          desc20: 'Five force drive scores ready',
          desc21: 'Analysis complete! Your ad performance report is ready',
          terminology: {
            thumbExpand: 'Expand Thumbnails',
            thumbCollapse: 'Collapse Thumbnails',
            gazeRecognition: 'Gaze Recognition',
            gazeRecognitionDesc:
              'Measures visual attention concentration, indicating how effectively ad elements capture viewer focus.',
            emotionRecognition: 'Emotion Recognition',
            emotionRecognitionDesc:
              'Quantifies positive emotions and immediate affective responses triggered by the ad.',
            engagementRecognition: 'Engagement Recognition',
            engagementRecognitionDesc:
              'Measures immersion and engagement, reflecting the mental investment in the ad content.',
            theGolden3Seconds: 'Golden 3s Performance',
            theGolden3SecondsDesc:
              'Evaluates the effectiveness of the ad’s content during the initial 3 seconds.',
            keyMessage: 'Key Message Performance',
            keyMessageDesc:
              'Measure the ability of ad information moments to capture attention and stimulate interest.',
            brand: 'Brand Performance',
            brandDesc: 'Assesses brand-specific attention capture and engagement effectiveness.',
            interest: 'Interest Peak',
            interestDesc:
              'Identifies content peaks triggering emotional resonance and high engagement.',
            ending3Seconds: 'Ending 3s Performance',
            ending3SecondsDesc:
              'Evaluates the effectiveness of the ad’s content in the ending 3 seconds.',
            score: 'Score',
            benchmark: 'Benchmark',
            metrics: 'Metrics',
            attitudePart: {
              attitudeMetrics: 'Attitude Metrics',
              liking: 'Liking',
              likingDesc: 'Measures the audience\'s subjective attitude and overall degree of liking toward the advertisement.',
              newInformation: 'New Information',
              newInformationDesc: 'Measures whether the audience subjectively believes they gained previously unknown, valuable information about the brand or product from the advertisement.',
              messageRelevance: 'Message Relevance',
              messageRelevanceDesc: 'Measures the extent to which the audience subjectively perceives the information conveyed in the advertisement as directly related to themselves.',
              comprehension: 'Comprehension',
              comprehensionDesc: 'Measures whether the key message of the advertisement was clearly, accurately, and effortlessly understood by the audience.',
              credibility: 'Credibility',
              credibilityDesc: 'Measures the extent to which the audience believes the information conveyed in the advertisement is true, reliable, and trustworthy.',
              brandLinkage: 'Brand Linkage',
              brandLinkageDesc: 'Measures the audience’s ability to correctly and strongly associate the advertisement with the specific brand.',
              uniqueness: 'Uniqueness',
              uniquenessDesc: 'Measures whether the advertisement successfully establishes a clear perception that the brand has distinct and valuable uniqueness compared to competitors.',
              willing: 'Willingness to Learn More',
              willingDesc: 'Measures the audience’s subjective likelihood of taking active steps to further explore and learn about the brand or product after viewing the advertisement.',
              purchase: 'Purchase Intention',
              purchaseDesc: 'Measures the audience’s subjective likelihood of considering choosing or purchasing the brand’s product at some point in the future after viewing the advertisement.',
              share: 'Shareability',
              shareDesc: 'Measures the audience’s subjective likelihood of proactively sharing the advertisement or brand information with others after viewing.',
              brandLikeLift: 'Brand Likeability Lift',
              brandLikeLiftDesc: 'Measures the direction and degree of change in the audience’s overall liking toward the brand or product after exposure to the advertisement.',
              purchaseIntentLift: 'Purchase Intent Lift',
              purchaseIntentLiftDesc: 'Measures the direction and degree of change in the audience’s willingness to consider purchasing the brand’s product after exposure to the advertisement.',
            },
            dimensionPart: {
              forceDrives: 'Force Drives',
              attension: 'Attension',
              emotionalImpact: 'Emotional Impact',
              messageClarity: 'Message Clarity',
              brandPower: 'Brand Power',
              persuasion: 'Persuasion',
              attentionForce: 'Attention Force',
              attentionForceDesc: 'Measures the ad\'s ability to capture and hold the audience\'s visual and auditory attention.',
              emotionalForce: 'Emotional Force',
              emotionalForceDesc: 'Measures the intensity of immediate, instinctive emotional resonance and fluctuation evoked by the ad content.',
              messageForce: 'Message Force',
              messageForceDesc: 'Measures the effectiveness of the ad\'s core message being clearly identified, accurately understood, and deeply remembered by the target audience.',
              brandForce: 'Brand Force',
              brandForceDesc: 'Measures the ad\'s efficacy in reinforcing brand identity, enhancing brand favorability, and building a strong brand connection.',
              persuasiveForce: 'Persuasive Force',
              persuasiveForceDesc: 'Measures the ad\'s ultimate power to shift user perceptions and drive behavioral intentions.',
            },
            result: {
              results: 'Results',
              pass: 'Pass',
              notPass: 'Not Pass',
              adeffScore: 'AdEff Score',
              adeffScoreDesc: 'The AdEff score is designed to measure the overall effectiveness of advertisements.',
              benchmarkDesc: 'The average AdEff score of all uploaded advertisements within the country/region where the ad is located is used to benchmark the ad’s performance in that specific country/region.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Waiting...',
            description: 'Generating the test report for you...',
          },
          generating: 'Generating...',
          freeTrialLockText1: 'Full report preview and download are unavailable during the trial. Upgrade to',
          freeTrialLockText2: 'unlock access.',
        },
      },
    },
  },
  professor: {
    account: 'Account',
    password: 'Password',
    login: 'Login',
    expertReviews: 'Expert Reviews',
    adVideoScore: 'AdEff index',
    subjectiveResponseCurve: 'Subjective Response Curve',
    indexAnalysis: 'Index Analysis',
    keyResult: 'Key Results',
    theGolden3Seconds: 'The Golden 3s',
    informationTransmission: 'Key Message Moment',
    brandRelevance: 'Brand Moment',
    interestStimulation: 'Interest Moment',
    theEnding3Seconds: 'The Ending 3s',
    heatMap: 'Heatmap',
    suggestion: 'Suggestion',
    suggestion1: 'Suggestion',
    submit: 'Submit',
    next: 'Next',
    summary: 'Summary',
    advantages: 'Strengths',
    disadvantages: 'Weaknesses',
    option1: 'Expected',
    option2: 'Unexpected',
    resultJudgment: 'Result Judgment',
    placeholder: 'Please enter a suggestion',
    waitRateCount: 'Number of ads to be evaluated',
    unfinishedTitle: 'Notification',
    unfinishedRate: 'The current project has unevaluated content, do you want to confirm exit?',
    unfinishedConfirm: 'Continue evaluation',
    unfinishedCancel: 'Exit',
    message: {
      submitSuccess: 'Thank you for your feedback',
      submitSuccess1:
        'You have completed the evaluation of this project, thank you for your feedback',
      loginSuccess: 'Login successfully',
      rateUnfinished:
        'You have not yet evaluated the current content, please complete it before proceeding to the next question',
      rateLocation: 'We have automatically located the unevaluated content for you',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Apply for a trial',
      title1: 'Free Trial',
      trial: 'Trial',
      hiddenBoxText1: 'Detected multiple strengths, weaknesses, and suggestions',
      hiddenBoxText2: 'Subscribe to get the complete report',
      hiddenBoxBtn: 'Subscribe Now',
      applyBox: {
        name: 'Your Name',
        tel: 'Contact Number',
        department: 'Department',
        role: 'Role',
        country: 'Country',
        city: 'City',
        pleaseEnter: 'Please enter',
        pleaseSelect: 'Please select',
        pleaseEnterTheName: 'Please enter your name',
        pleaseEnterTheTel: 'Please enter your contact number',
        pleaseEnterValidTel: 'Please enter a valid contact number',
        pleaseEnterValidEmail: 'Please enter a valid email',
        pleaseSelectTheDepartment: 'Please select our department',
        pleaseSelectTheRole: 'Please select your role',
        pleaseSelectTheCountry: 'Please select your country',
        pleaseEnterTheCity: 'Please enter your city',
        textIsRequired: 'This field is required',
        submit: 'Submit',
        tip: 'Each company has only one free trial opportunity',
      },
      gotTrial: 'You’ve got a trial!',
      goPc: 'Please go to the PC web version to create your project.',
      back: 'Go Back',
      country: {
        China: 'China',
        Japan: 'Japan',
        Korea: 'Korea',
        Indonesia: 'Indonesia',
        Thailand: 'Thailand',
        Singapore: 'Singapore',
        Malaysia: 'Malaysia',
        Vietnam: 'Vietnam',
        Germany: 'Germany',
        Britain: 'Britain',
        France: 'France',
        Italy: 'Italy',
        Russia: 'Russia',
        Spain: 'Spain',
        Turkey: 'Turkey',
        America: 'America',
        Canada: 'Canada',
        Brazil: 'Brazil',
        Other: 'Other',
      },
      department: {
        Brand: 'Brand',
        Market: 'Market',
        Marketing: 'Marketing',
        IT: 'IT',
        Procurement: 'Procurement',
        Other: 'Other',
      },
      role: {
        President: 'President/Vice President/General Manager',
        CMO: 'CMO or Other C-level Management',
        Director: 'Department Director',
        Manager: 'Department Manager',
        Other: 'Other',
      },
      message: {
        submitSuccess: 'Submit successfully',
        submitFailed: 'Submit failed, please try again later',
      },
    },
    downloadPptRechargeModal: {
      title: 'Unable to download',
      desc1: 'Download is not available in trial mode',
      desc2: 'Subscribe to get the complete report',
      btn: 'Subscribe Now',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Referral Code',
      invitationCodeDesc1:
        'Referral code information cannot be modified, please contact us if you need to modify it',
      invitationCodeDesc2:
        'If you are using this through an agent referral, please enter the referral code',
      invitationCodePlaceholder: 'Please enter the referral code',
      invitationCodeError: 'Invalid referral code',
      invitationCodeSuccess: 'Binding successfully',
      ok: 'OK',
      cancel: 'Cancel',
    },
    aigcPromotionModal: {
      title: 'AIGC Creator Benefits',
      subTitle: 'Sign up to get <tmp>5</tmp> AI video evaluation opportunities',
      desc1: 'Join the AdEff AI Creative Testing Event to evaluate your creatives. ',
      desc2: 'Register now and instantly claim 5 free tests.',
      registerBtn: 'Sign up for test opportunities',
      tip: 'Only for new users registered through the AIGC creator campaign entry',
      floatTitle: 'Free testing',
    },
  },
}

export default TRANSLATION
